import lodashGet from 'lodash/get';
import lodashSet from 'lodash/set';
import { shallowEqual } from 'react-redux';
import { delay, getContext, select } from 'redux-saga/effects';
import { createSelector } from 'reselect';

import { ERROR_TYPES } from 'constants/errors';
import AppError from 'utils/errors/AppError';

import { SKIP_SYMBOL } from './constants';

export const updateState = ({ payload, state }) => {
  const result = Object.entries(payload).reduce(
    (acc, [key, value]) => {
      const current = acc[key];

      if (!shallowEqual(current, value)) {
        acc[key] = value;
      }

      return acc;
    },
    { ...state }
  );

  // Не обновляем store без необходимости
  if (shallowEqual(state, result)) {
    return state;
  }

  return result;
};

export const updateObjectState = ({ name, payload, state }) => {
  const { [name]: target } = state;

  const result = updateState({ payload, state: target });

  // Не обновляем store без необходимости
  if (shallowEqual(target, result)) {
    return state;
  }

  return { ...state, [name]: result };
};

/**
 * @callback SelectFactoryResultImplement
 * @param {string[]|string|symbol} path
 * @param {any} [fallback] - дефолтное значение
 * @return {Function}
 * */
/**
 * @callback SelectFactoryImplement
 * @param {Object} params
 * @param {any} params.fallback
 * @param {Function} params.selector
 * @return SelectFactoryResultImplement
 * */
/** @type {SelectFactoryImplement} */
export const selectFactory = ({ fallback: fallbackFactory, selector }) => {
  return (...args) => {
    if (!args.length) {
      throw new Error('Incorrect selector');
    }

    if (args.length === 1 && typeof fallbackFactory !== 'undefined') {
      args.push(fallbackFactory);
    }

    const [path, fallback] = args;

    return createSelector(selector, (state) => {
      return lodashGet(state, path, fallback);
    });
  };
};

export const transformListToObject = ({ list, value }) => {
  const result = {};

  if (!Array.isArray(list)) {
    return result;
  }

  for (const field of list) {
    lodashSet(result, field, value);
  }

  return result;
};

export function* selectWhen(selector, is, timeout = 10 * 1000) {
  const start = Date.now();

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const result = yield select(selector);
    let correctResult = typeof result !== 'undefined';

    if (typeof is === 'function') {
      correctResult = is(result);
    } else if (typeof is !== 'undefined') {
      correctResult = result === is;
    }

    if (correctResult) {
      return result;
    }

    if (Date.now() - start > timeout) {
      throw new AppError(
        "Couldn't get data from the store",
        undefined,
        ERROR_TYPES.REDUX_SELECT_WHEN
      );
    }

    yield delay(100);
  }
}

export function* skipped() {
  return yield getContext(SKIP_SYMBOL);
}
